import { handleSettledPromises } from '@kk/shared/utils/async';
import { assertParamsPrescence } from '@kk/shared/utils/validators';
import { useRouteLoaderData } from 'react-router';
import { assertNoLoaderErrors } from '#/api/errors';
import { fetchCompanyInfoQuery } from '#/api/hooks/useCompanyInfo';
import { fetchExternalUserInfoQuery } from '#/api/hooks/useUserInfo';
import type { InferLoaderData } from '#/routes/types';

export type LoaderData = InferLoaderData<typeof loader>;

export type Params = Record<string, string | undefined>;

export const id = 'profilePage' as const;

async function loader({ params }: { params: Params }) {
  assertParamsPrescence(params);

  const data = await handleSettledPromises([
    fetchExternalUserInfoQuery(),
    fetchCompanyInfoQuery(),
  ]);

  assertNoLoaderErrors(id, data);

  const [userInfo, companyInfo] = data;
  return { userInfo, companyInfo };
}

export const useProfilePageLoaderData = () =>
  useRouteLoaderData(id) as LoaderData;

export default loader;
